import clsx from 'clsx';
import React from 'react';

import type { HorizontalRuleBlockConfig } from '../interfaces';
import { backgroundColorValues, colorValues } from './constants';

const HorizontalRuleBlock = ({ config }: { config: HorizontalRuleBlockConfig }) => {
  return (
    <hr
      className={clsx(
        'horizontal-rule-block',
        config?.css_classes,
        backgroundColorValues[config?.border_color],
        colorValues[config?.border_color]
      )}
      style={{ height: `${config?.thickness}px`, opacity: config?.opacity }}
    />
  );
};

export default HorizontalRuleBlock;
